import React from "react";

export default function BsXCircleFill(props) {
  const { size = 16 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        fill="red" // Fill the circle with red color
        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"
      ></path>
      <path
        fill="white" // White 'X' inside the circle
        d="M5.354 5.354a.5.5 0 0 1 .707 0L8 7.293l1.939-1.939a.5.5 0 1 1 .707.707L8.707 8l1.939 1.939a.5.5 0 0 1-.707.707L8 8.707l-1.939 1.939a.5.5 0 1 1-.707-.707L7.293 8 5.354 6.061a.5.5 0 0 1 0-.707z"
      ></path>
    </svg>
  );
}
